(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YieldCurveResultsDetailController', YieldCurveResultsDetailController);

    YieldCurveResultsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'YieldCurveResults', 'Quoting', 'EpmParams', 'PaperPrice', 'YieldCurvePoint', 'ParCurvePoint'];

    function YieldCurveResultsDetailController($scope, $rootScope, $stateParams, previousState, entity, YieldCurveResults, Quoting, EpmParams, PaperPrice, YieldCurvePoint, ParCurvePoint) {
        var vm = this;

        vm.yieldCurveResults = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:yieldCurveResultsUpdate', function(event, result) {
            vm.yieldCurveResults = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
